import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { DatePicker } from "rsuite";
import {
  createPackageType,
  createPlayerSubscription,
  getPackageDuration,
  getPackageType,
  getPackageTypeEnum,
  getPlayerSubscription,
} from "../../../services/academicService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Package Type", sortingVale: "packageTypeEnum" },
  { heading: "Duration type", sortingVale: "duration" },
  { heading: "Days/Hours", sortingVale: "durationValue" },
  { heading: "Description", sortingVale: "description" },
  { heading: "Actions", sortingVale: "actions" },
];

const PackageType = () => {
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [subscription, setSubscription] = useState([]);
  const [packageType, setPackageType] = useState([]);
  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [packageTime, setPackageTime] = useState([]);
  const [selectedPackageTime, setSelectedPackageTime] = useState(null);
  const [packageEnum, setPackageEnum] = useState([]);
  const [selectedPackageEnum, setSelectedPackageEnum] = useState(null);
  const [selectedCronJob, setSelectedCronJob] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    packageTime: "",
    packageEnum: "",
    days: "",
    time: "",
    cronJob: "",
  });

  function SotingData(name) {
    const sortedPeople = [...subscription];
    switch (name) {
      case "packageType":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.packageType.localeCompare(b.packageType)
            : b.packageType.localeCompare(a.packageType);
        });
        break;

      case "description":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.description.localeCompare(b.description)
            : b.description.localeCompare(a.description);
        });
        break;

      default:
        break;
    }
    setSubscription(sortedPeople);
  }

  function DataSearch(e) {
    const updatesDate = subscription.filter((item) => {
      let selectdata = `${item.name} `.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setSubscription([...updatesDate]);
  }

  // const validate = () => {
  //   const newErrors = {};

  //   if (!formData.name) newErrors.name = "Name is required";

  //   if (selectedPackageTime?.value === "Daily") {
  //     if (!formData.days || isNaN(formData.days) || formData.days <= 0) {
  //       newErrors.days = "Please enter a valid number of days";
  //     }
  //   } else {
  //     if (!formData.time || isNaN(formData.time) || formData.time <= 0) {
  //       newErrors.time = "Please enter a valid number of hours";
  //     }
  //   }

  //   if (!selectedPackageEnum)
  //     newErrors.packageEnum = "Package Type selection is required";

  //   if (selectedPackageEnum?.value === "CUSTOM" && !selectedCronJob) {
  //     newErrors.cronJob = "Cron Job selection is required";
  //   }

  //   setErrors(newErrors);

  //   return Object.keys(newErrors).length === 0; // return true if no errors
  // };

  const validate = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = "Name is required";
    }

    if (!selectedPackageEnum) {
      newErrors.packageEnum = "Package Type selection is required";
    }

    // 🔥 CUSTOM-only validation
    if (selectedPackageEnum?.value === "CUSTOM") {
      if (!selectedPackageTime) {
        newErrors.packageTime = "Package Time selection is required";
      }

      if (selectedPackageTime?.value === "Daily") {
        if (!formData.days || isNaN(formData.days) || formData.days <= 0) {
          newErrors.days = "Please enter a valid number of days";
        }
      } else if (selectedPackageTime) {
        if (!formData.time || isNaN(formData.time) || formData.time <= 0) {
          newErrors.time = "Please enter a valid number of hours";
        }
      }

      if (!selectedCronJob) {
        newErrors.cronJob = "Cron Job selection is required";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    fetchPackageType();
    fetchPackageTime();
    fetchPackageTypeEnum();
  }, []);

  async function fetchPackageType() {
    try {
      const res = await getPackageType();
      setSubscription(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchPackageTypeEnum() {
    try {
      const res = await getPackageTypeEnum();
      const formattedPackageEnum = res?.map((item) => ({
        value: item?.value,
        label: item?.key,
      }));
      setPackageEnum(formattedPackageEnum);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchPackageTime() {
    try {
      const res = await getPackageDuration();
      setPackageTime(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const payload = {
      name: formData.name,
      description: formData.description,
      packageTypeEnum: selectedPackageEnum.value,
    };

    // Add CUSTOM-specific fields to payload if packageEnum is CUSTOM
    if (selectedPackageEnum?.value === "CUSTOM") {
      payload.packageTime = selectedPackageTime?.value;
      payload.days = formData.days;
      payload.hours = formData.time;
      if (selectedCronJob) {
        payload.cronJob = selectedCronJob.value;
      }
    }

    // If editing, include id
    if (editingId) {
      payload.id = editingId;
    }

    try {
      const res = await createPackageType(payload);
      if (res) {
        toast.success(
          editingId
            ? "Updated Subscription successfully!"
            : "Created Subscription successfully!",
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        fetchPackageType();
        handleCancel();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // const handleCancel = () => {
  //   setSelectedPackageType(null);
  //   setFormData({
  //     name: "",
  //     description: "",
  //     days: "",
  //     hours: "",
  //     cronJob: "",
  //   });
  //   setErrors({});
  //   setPackageType(null);
  //   setSelectedPackageTime(null);
  //   setEditingId(null);
  // };

  const handleCancel = () => {
    setFormData({
      name: "",
      description: "",
      days: "",
      time: "",
    });

    setSelectedPackageEnum(null);
    setSelectedPackageTime(null);
    setSelectedCronJob(null);

    setEditingId(null);
    setErrors({});
  };

  return (
    <>
      <PageTitle activeMenu={"All Package"} motherMenu={"Packages"} />
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                Package Type {editingId ? "Updation" : "Creation"}
              </h5>
            </div>

            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        id="name"
                        name="name"
                        placeholder="Enter Package Type"
                        type="text"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      {errors.name && (
                        <small className="text-danger m-lg-2">
                          {errors.name}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="description">
                        Package Type <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        value={selectedPackageEnum}
                        options={packageEnum}
                        onChange={(d) => {
                          setSelectedPackageEnum(d);
                          setErrors((prev) => ({
                            ...prev,
                            packageEnum: "",
                          }));
                        }}
                        placeholder="Select Package Type"
                        className="custom-react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.packageEnum
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.packageEnum
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.packageEnum
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.packageEnum && (
                        <small className="text-danger m-lg-2">
                          {errors.packageEnum}
                        </small>
                      )}
                    </div>
                  </div>
                  {selectedPackageEnum?.value === "CUSTOM" && (
                    <>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="description">
                            Package Time <span className="required">*</span>
                          </label>
                          <Select
                            isSearchable={false}
                            value={selectedPackageTime}
                            options={packageTime}
                            onChange={(d) => {
                              setSelectedPackageTime(d);
                              setErrors((prev) => ({
                                ...prev,
                                packageTime: "",
                              }));
                            }}
                            placeholder="Select Package Type"
                            className="custom-react-select"
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: errors.packageTime
                                  ? "#FF1616"
                                  : base.borderColor,
                                boxShadow: errors.packageTime
                                  ? "0 0 0 1px #FF1616"
                                  : base.boxShadow,
                                "&:hover": {
                                  borderColor: errors.packageTime
                                    ? "#FF1616"
                                    : base.borderColor,
                                },
                              }),
                            }}
                          />
                          {errors.packageTime && (
                            <small className="text-danger m-lg-2">
                              {errors.packageTime}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label">
                            Duration in{" "}
                            {selectedPackageTime?.value === "Daily"
                              ? "Days"
                              : "Hours"}
                            <span className="required">*</span>
                          </label>
                          {selectedPackageTime?.value === "Daily" ? (
                            <>
                              <input
                                name="days"
                                type="number"
                                placeholder="Enter Duration in Days"
                                className={`form-control ${
                                  errors.days ? "is-invalid" : ""
                                }`}
                                value={formData.days}
                                onChange={handleChange}
                              />
                              {errors.days && (
                                <small className="text-danger m-lg-2">
                                  {errors.days}
                                </small>
                              )}
                            </>
                          ) : selectedPackageTime ? (
                            <>
                              <input
                                name="time"
                                type="number"
                                placeholder="Enter Duration in Hours"
                                className={`form-control ${
                                  errors.time ? "is-invalid" : ""
                                }`}
                                value={formData.time}
                                onChange={handleChange}
                              />
                              {errors.time && (
                                <small className="text-danger m-lg-2">
                                  {errors.time}
                                </small>
                              )}
                            </>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="description">
                            Cron Job<span className="required">*</span>
                          </label>
                          <Select
                            isSearchable={false}
                            value={selectedCronJob}
                            options={[
                              { label: "Yes", value: true },
                              { label: "No", value: false },
                            ]}
                            onChange={(d) => {
                              setSelectedCronJob(d);
                              setErrors((prev) => ({ ...prev, cronJob: "" }));
                            }}
                            placeholder="Generate Bills daily?"
                            className="custom-react-select"
                            styles={{
                              control: (base) => ({
                                ...base,
                                borderColor: errors.cronJob
                                  ? "#FF1616"
                                  : base.borderColor,
                                boxShadow: errors.cronJob
                                  ? "0 0 0 1px #FF1616"
                                  : base.boxShadow,
                                "&:hover": {
                                  borderColor: errors.cronJob
                                    ? "#FF1616"
                                    : base.borderColor,
                                },
                              }),
                            }}
                          />
                          {errors.cronJob && (
                            <small className="text-danger m-lg-2">
                              {errors.cronJob}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="description">
                        Description
                      </label>
                      <input
                        id="description"
                        name="description"
                        placeholder="Enter Description"
                        className="form-control"
                        type="text"
                        textarea
                        value={formData.description}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading
                        ? editingId
                          ? "Updating..."
                          : "Submitting..."
                        : editingId
                          ? "Update"
                          : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={handleCancel}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            {/* <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav> */}
          </div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Package Type List</h4>
                    {/* <button
                      onClick={() => setVisible(true)}
                      className="btn btn-primary"
                    >
                      + Add New
                    </button> */}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length"></div>
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                onChange={DataSearch}
                              />
                            </label>
                          </div>
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {subscription?.map((data, ind) => (
                              <tr key={ind}>
                                <td>{ind + 1}</td>
                                <td>{data?.name}</td>
                                <td>{data?.packageTypeEnum}</td>
                                <td>{data?.packageTime}</td>
                                <td>
                                  {data?.packageTime === "Daily" && data?.days
                                    ? `${data.days} Days`
                                    : data?.packageTime !== "Daily" &&
                                        data?.hours
                                      ? `${data.hours} Hours`
                                      : "--"}
                                </td>
                                <td>{data?.description}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-s sharp btn-primary me-1"
                                    // onClick={() => {
                                    //   setEditingId(data.id);
                                    //   setFormData({
                                    //     name: data.name || "",
                                    //     description: data.description || "",
                                    //     days: data.days || "",
                                    //     time: data.time || "",
                                    //     cronJob: data.cronJob || "",
                                    //   });
                                    //   setSelectedPackageTime(
                                    //     packageTime.find(
                                    //       (pt) => pt.value === data.packageTime
                                    //     ) || null
                                    //   );
                                    //   setErrors({});
                                    // }}
                                    onClick={() => {
                                      setEditingId(data.id);

                                      setFormData({
                                        name: data.name || "",
                                        description: data.description || "",
                                        days: data.days || "",
                                        time: data.hours || "",
                                      });

                                      // Package Enum
                                      setSelectedPackageEnum(
                                        packageEnum.find(
                                          (pe) =>
                                            pe.value === data.packageTypeEnum,
                                        ) || null,
                                      );

                                      // Package Time
                                      setSelectedPackageTime(
                                        packageTime.find(
                                          (pt) => pt.value === data.packageTime,
                                        ) || null,
                                      );

                                      // Cron Job (boolean)
                                      setSelectedCronJob(
                                        typeof data.cronJob === "boolean"
                                          ? {
                                              label: data.cronJob
                                                ? "Yes"
                                                : "No",
                                              value: data.cronJob,
                                            }
                                          : null,
                                      );

                                      setErrors({});
                                    }}
                                  >
                                    <i className="fa fa-pencil" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default PackageType;
